import styled, {css} from "styled-components";
import {SwedenResponsibleGamingButtonBaseBox} from "../../boxes/sweden.responsible-gaming-button-base.box";

export const SwedenSelfTestButtonBox = styled(SwedenResponsibleGamingButtonBaseBox)<{useIconsOnly: boolean, isShownInHeader: boolean}>`
  ${props => props.isShownInHeader ? css`
     width: 8.5rem;
     height: 2.5rem;
  `: null}
`;